import React, { useState, useEffect } from 'react';
import '../App.css';
import { motion } from 'framer-motion';

import { useNavigate } from 'react-router-dom';
import HoverBorderButton from "../Components/HoverBorderButton";

export default function Productspicture({title, productsList}) {
  
 const [hoveredIndex1, setHoveredIndex1] = useState(null);
 const [hoveredIndex2, setHoveredIndex2] = useState(null);
  const handleCardClick = (id) => {
    if (id !== "") {
      const url = `/Products/${id}`;
      window.open(url, '_blank');
    } else {
      console.log('Invalid ID: Cannot open new window');
    }
  };

  

  return (
    <div className="w-full  flex items-center justify-center bg-primary7 mb-20">
      {/* Main Container */}
      <div className="w-full flex flex-col gap-12 h-full">
        {/* LEFT SIDE (40%) */}
        <div className=" flex items-center justify-center">
          <p className="text-white opacity-40 font-RobotoBold font-extrabold uppercase 2xl:text-[68px] sm:text-[54px] text-[32px] tracking-[.25em] text-center">
           {title}
          </p>
        </div>

        {/* RIGHT SIDE (60%) */}
        <div className=" flex items-center justify-center">
          {/* GRID (2 per row) */}
          <div className="w-full max-w-[1024px] grid grid-cols-2 lg:grid-cols-4 gap-6 sm:px-36">
            {productsList.slice(0, 4).map((product, index) => (
              <div
                key={index}
                className="flex flex-col items-center justify-center sm:gap-3 cursor-pointer group relative"
                onMouseEnter={() => setHoveredIndex1(index)}
                onMouseLeave={() => setHoveredIndex1(null)}
                onClick={() => product.name && handleCardClick(product.name)}
              >
                {/* IMAGE */}
                <div
                  className={`transition-transform duration-300 ${
                    hoveredIndex1 === index ? "scale-110" : "scale-100"
                  }`}
                >
                  <img
                    src={product.image}
                    alt={product.title}
                    className="w-32 h-32 object-contain"
                  />
                </div>

                {/* TITLE */}
                {/* <p className="text-white text-center font-Quantify text-sm">
                  {product.title}
                </p> */}

                {/* HOVER BOX */}
                {hoveredIndex1 === index && product.headline && (
                  <div className="absolute top-[-110%] bg-black py-3 px-4 rounded-2xl border border-[#444D61] text-center w-[200px]">
                    <h4 className="text-[#1B99D4] text-xs font-RobotoBold mb-1">
                      {product.headline}
                    </h4>

                    {/* {product.name ? (
                      <HoverBorderButton
                        containerClassName="rounded-full mt-2"
                        as="button"
                        className="bg-black font-RobotoMedium text-xs text-white px-3 py-1"
                        onClick={() => handleCardClick(product.name)}
                      >
                        {product.content}
                      </HoverBorderButton>
                    ) : ( */}
                      <p className="text-white text-[0.7rem] mt-1">
                        {product.content}
                      </p>
                    {/* )} */}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}



